export default __webpack_public_path__ + "static/media/fullstack.b23279da.png";